import Http from '@/classes/http/Http'

export default {
  startReportingCase (reportId) {
    return Http.post({
      url: `report-periods/${reportId}/cases`,
      data: {}
    })
  }
}
